// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"b5b12ccfbd7fe2240e5c","453":"82a578d39c85801294ed"}[chunkId] + ".js";
};